import { render } from "./SystemCleanUpConfig.vue?vue&type=template&id=75350a5d&scoped=true&ts=true"
import script from "./SystemCleanUpConfig.vue?vue&type=script&lang=ts"
export * from "./SystemCleanUpConfig.vue?vue&type=script&lang=ts"

import "./SystemCleanUpConfig.vue?vue&type=style&index=0&id=75350a5d&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75350a5d"]])

export default __exports__